import React from "react";

/**
 * Minimal premium VG monogram — Swiss corporate identity style.
 * - Single subtle globe ring
 * - Clean V + G letterforms with shared baseline
 * - One understated upward accent (gold) for "growth"
 * - No competing arrows, no busy ornamentation
 */
export const VynexLogo = ({ size = 44, variant = "light" }) => {
  // variant: "light" (for dark bg) | "dark" (for light bg)
  const stroke = variant === "light" ? "#ffffff" : "#061b33";
  const ringColor = variant === "light" ? "#d9dee5" : "#061b33";
  const emerald = "#087a55";
  const gold = "#c99a3a";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Vynex Global"
      data-testid="vynex-logo"
    >
      {/* Subtle globe ring */}
      <circle
        cx="32"
        cy="32"
        r="28"
        stroke={ringColor}
        strokeOpacity={variant === "light" ? 0.45 : 0.25}
        strokeWidth="1"
        fill="none"
      />
      {/* Single soft meridian */}
      <ellipse
        cx="32"
        cy="32"
        rx="11"
        ry="28"
        stroke={ringColor}
        strokeOpacity={variant === "light" ? 0.18 : 0.12}
        strokeWidth="0.75"
        fill="none"
      />

      {/* V monogram - clean geometric strokes */}
      <path
        d="M19 22 L29 44 L32 38"
        stroke={stroke}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* G monogram - balanced with V */}
      <path
        d="M45 24
           C 45 19.5, 41 17, 37 17
           C 32 17, 29 21.5, 29 27
           C 29 32.5, 32 37, 37 37
           L 37 30.5
           L 33.5 30.5"
        stroke={emerald}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* One understated upward accent — slim diagonal tick */}
      <path
        d="M47 23 L51 19"
        stroke={gold}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default VynexLogo;
